<script setup>

import dayjs from "dayjs";
import {computed, ref} from "vue";
import MaskIcon from "@/Components/MaskIcon.vue";
import {route} from "ziggy-js";

const props = defineProps({
    message: Object,
    participants: Array,
})

const buyer = ref(null),
    seller = ref(null)

props.participants.forEach(participant => {
    if (participant.user.id === props.message.order.offer.user.id) {
        seller.value = participant.user
    } else {
        buyer.value = participant.user
    }
})

const PLACEHOLDERS = ['{seller}', '{order}', '{offer}', '{buyer}']

// props.message.template is a trusted i18n string (may contain static markup like <br>),
// but the offer title substituted into {offer} is free-form seller-supplied text. Instead of
// building one HTML string by hand and escaping the risky parts ourselves before dumping it
// into v-html, split the template around the placeholders and let Vue's own text
// interpolation ({{ }}, which escapes automatically) render every substituted value. Only the
// static, translation-authored chunks in between - never a substituted value - go through
// v-html.
const templateParts = computed(() => {
    const template = props.message.template
    const pattern = new RegExp(PLACEHOLDERS.map(p => p.replace(/[{}]/g, '\\$&')).join('|'), 'g')
    const parts = []
    let lastIndex = 0
    let match

    while ((match = pattern.exec(template)) !== null) {
        if (match.index > lastIndex) {
            parts.push({type: 'html', value: template.slice(lastIndex, match.index)})
        }
        parts.push({type: 'placeholder', value: match[0]})
        lastIndex = match.index + match[0].length
    }
    if (lastIndex < template.length) {
        parts.push({type: 'html', value: template.slice(lastIndex)})
    }

    return parts
})

</script>

<template>
    <div class="bg-green-100 dark:bg-emerald-600 rounded-lg px-2 py-1">
        <div class="flex justify-between leading-120 mb-1">
            <span class="text-blue-600 text-sm dark:text-cyan-300">ANYKOD</span>
            <span
                class="text-xs text-slate-500 font-normal dark:text-slate-400">{{
                    dayjs(message.created_at).format('HH:mm')
                }}</span>
        </div>
        <div class="flex gap-1">
            <div class="w-3.5 h-3.5">
                <MaskIcon src="/assets/icons/attention.svg" class="w-3.5 h-3.5 bg-blue-600 dark:bg-cyan-300"/>
            </div>

            <p class="text-sm leading-120 tracking-wider font-normal dark:text-slate-200">
                <template v-for="(part, index) in templateParts" :key="index">
                    <span v-if="part.type === 'html'" v-html="part.value"/>
                    <a v-else-if="part.value === '{seller}'"
                       :href="route('users.show.offers', {user: seller})"
                       class="text-blue-600 dark:text-cyan-300 font-medium" target="_blank">{{ seller?.name }}</a>
                    <a v-else-if="part.value === '{order}'"
                       :href="route('orders.show', message.order)"
                       class="text-blue-600 dark:text-cyan-300 font-medium" target="_blank">{{ message.order?.code }}</a>
                    <span v-else-if="part.value === '{offer}'">{{ message.order?.offer.title }}</span>
                    <a v-else-if="part.value === '{buyer}'"
                       :href="route('users.show.reviews', {user: buyer})"
                       class="text-blue-600 dark:text-cyan-300 font-medium" target="_blank">{{ buyer?.name }}</a>
                </template>
            </p>
        </div>

    </div>
</template>

<style scoped>

</style>
